/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IStackProps, Stack } from '@fluentui/react/lib/Stack';
import * as React from 'react';
import { getStylist } from 'src/core/themes/luisStylist';

const defaultHeight = 300;
const defaultWidth = 240;

const { styleComponent } = getStylist('Tile');

type TileProps = {
    /**
     * The width of the tile to set.
     */
    width?: number;

    /**
     * The height of the tile to set.
     */
    height?: number;
    children?: React.ReactNode;
};

const LuisStack = styleComponent<IStackProps>(Stack)<{ height: number; width: number }>(
    'Tile',
    theme => ({
        backgroundColor: theme.backgroundColor,
        boxShadow: theme.boxShadow,
        borderRadius: theme.borderRadius
    }),
    ({ customProps }) => ({
        height: customProps.height || defaultHeight,
        width: customProps.width || defaultWidth
    })
);

/**
 * Represents a tile like card. To add content in the tile, the sub
 * components of tile header, footer, and content should be used.
 *
 * @param props Properties that include custom height and width.
 */
export const Tile: React.FunctionComponent<TileProps> = props => <LuisStack>{props.children}</LuisStack>;
